import { setAdminNestToken } from './app/nestapi'
import { setNestToken } from '@marketing-milk/frontend'

export function setBearerGlobally(token: string | null) {
  setNestToken(token)
  setAdminNestToken(token)
}
